module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"show_message":"Show","hide_message":"Hide"},"es":{"show_message":"Ver","hide_message":"Ocultar"}}')
  delete Component.options._Ctor
}
